import exports from "@/assets/scss/exports.module.scss";
// MAIN COLORS - VUESAX THEME COLORS
export const colors = {
  primary: exports["colors-primary"],
  grey: exports["colors-grey"],
};

// CONFIGS
const themeConfig = {
  footerType: "static", // options[String]  : static(default) / sticky / hidden
  hideScrollToTop: false, // options[Boolean] : true, false(default)
  navbarColor: "#fff", // options[String]  : HEX color / rgb / rgba / Valid HTML Color name - (default: #fff)
  navbarType: "sticky", // options[String]  : floating(default) / static / sticky / hidden
  rtl: false, // options[Boolean] : true, false(default)
};

import Vue from "vue";
import Vuesax from "vuesax";
Vue.use(Vuesax, { theme: { colors }, rtl: themeConfig.rtl });

export default themeConfig;
